<template>
  <div v-if="filterCategoriesByCount.length">
    <v-container class="pt-3">
      <h4 class="title grey--text text--darken-1 pt-0 pb-0">
        <router-link
          class="grey--text text--darken-1 no-decoration"
          to="/category"
          v-html="$store.getters.getLangKey('categories')" />
      </h4>
    </v-container>
    <v-list dense>
      <v-list-tile
        ripple
        router
        v-for="(category, index) in filterCategoriesByCount"
        :key="index"
        :to="`/category/${category.slug}`">
        <v-list-tile-content>
          <v-list-tile-title v-html="category.title" />
        </v-list-tile-content>
        <v-list-tile-action v-html="category.post_count" />
      </v-list-tile>
    </v-list>
  </div>
</template>
<script>
  export default {
    name: 'CategoriesCloud',
    data () {
      return {
        categories: this.$store.state.bootstrapData.categories || [],
        minCount: this.$attrs['min-count'] || 0
      }
    },
    computed: {
      filterCategoriesByCount () {
        return this.categories.filter(category => category.post_count > this.minCount)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/CategoriesCloud.vue